webpackJsonp([156567224916705],{

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HTMLContent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 31/3/18
	 */
	var HTMLContent = exports.HTMLContent = function HTMLContent(_ref) {
	  var content = _ref.content,
	      className = _ref.className;
	  return _react2.default.createElement('div', { className: className, dangerouslySetInnerHTML: { __html: content } });
	};
	
	var Content = function Content(_ref2) {
	  var content = _ref2.content,
	      className = _ref2.className;
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    content
	  );
	};
	
	Content.propTypes = {
	  content: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	HTMLContent.propTypes = Content.propTypes;
	
	exports.default = Content;

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.albumPageQuery = exports.AlbumPageTemplate = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(14);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(38);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Content = __webpack_require__(52);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 31/3/18
	 */
	var AlbumPageTemplate = exports.AlbumPageTemplate = function AlbumPageTemplate(_ref) {
	  var _ref2;
	
	  var title = _ref.title,
	      content = _ref.content,
	      contentComponent = _ref.contentComponent,
	      featuredImage = _ref.featuredImage;
	
	  var PageContent = contentComponent || _Content2.default;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'section',
	      { className: 'hero is-primary is-bold' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body header-bgimage' },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          sizes: featuredImage.childImageSharp.sizes,
	          imgStyle: { objectPosition: 'center 20%' },
	          style: (_ref2 = {
	            background: 'linear-gradient(to top, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), linear-gradient(to bottom, rgba(0, 0, 0, 0.25), rgba(255, 255, 255, 0.75))',
	            backgroundSize: 'cover',
	            color: '#fff',
	            display: 'flex',
	            height: '300px'
	          }, _ref2['height'] = '40vh', _ref2.justifyContent = 'space-around', _ref2.left = 0, _ref2.position = 'absolute', _ref2.top = 0, _ref2.width = '100%', _ref2.zIndex = -5, _ref2)
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'body section is-paddingless album' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-12 is-offset-2 slide-up' },
	              _react2.default.createElement(
	                'div',
	                { className: 'content column is-4' },
	                _react2.default.createElement(PageContent, { className: 'content', content: content })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	AlbumPageTemplate.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  featuredImage: _propTypes2.default.string,
	  content: _propTypes2.default.string,
	  contentComponent: _propTypes2.default.func
	};
	
	var AlbumPage = function AlbumPage(_ref3) {
	  var data = _ref3.data;
	  var post = data.markdownRemark;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        post.frontmatter.meta_title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: post.frontmatter.meta_description })
	    ),
	    _react2.default.createElement(AlbumPageTemplate, {
	      contentComponent: _Content.HTMLContent,
	      title: post.frontmatter.title,
	      featuredImage: post.frontmatter.featuredImage,
	      content: post.html
	    })
	  );
	};
	
	AlbumPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = AlbumPage;
	var albumPageQuery = exports.albumPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-album-page-js-f2c68f618ac4dd6bda29.js